import { Button, Checkbox, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { ServerAPI } from '../../common/ServerAPI';
import PdfViewer from './PdfViewer';
import { API } from '../../common/Constants';


const SamplePreviewContainer = ({ productId, holderId, view }) => {
    const [data, setData] = useState("");
    const previewer = async () => {
        //console.log(holderId);
        const fileUrl = API.BaseUrl + API.EndPoint.loanApplicationForm + "/" + localStorage.getItem('applicationno') + "/" + productId;
        setData(fileUrl);
        //console.log(fileUrl)
    }

    useEffect(() => {
        previewer();
    }, [])
    return (
        <div>
            <PdfViewer pdfurl={data} view={view} />
        </div>
    );
};

export default SamplePreviewContainer;